// extracted by mini-css-extract-plugin
export default {"header":"modal-header_header__crv3F","title":"modal-header_title__A73vG","button":"modal-header_button__WqTSV"};